<template>
	<v-card outlined :height="currentHeight">
	<!-- :width="'79vw'"		 -->
		<v-card-text class="pa-1" >
			<v-row dense>
				<!-- <v-col cols="12">
					<v-card outlined>
						<v-card-title class="pa-0"> {{ $ml.get('tags') }}</v-card-title>
						<v-card-text class="pa-2">							
							<template v-for="(itemTag,idxTag) in infoToFilter.tags">							
								<v-btn :color="itemTag.isActive?'success':'secondary'"> {{$ml.get('face')}} #{{ idxTag }} </v-btn>
							</template>
						</v-card-text>
					</v-card>
				</v-col> -->
				<v-col cols="12">
					<v-card outlined class="pa-1">						
						<!-- <v-btn 
							
							v-for="item of listTypeSelection" 
							class="ma-1" 
							:key="'results'+item.key" 
							:color="selectedType.key==item.key?'success':'secondary'" 
							@click="renderSelectionType(item)"
						>
							{{ $ml.get(item.name) }}
						</v-btn>	 -->					
						<FilterSearch :listToComponent="infoToFilter.results" :infoToFilter="infoToFilter"></FilterSearch>
						<v-divider></v-divider>
						<component :is="selectedType.component" :listToComponent="infoToFilter.results"  :infoToFilter="infoToFilter" :open="open" :currentHeight="currentHeight-130" ></component>
					</v-card>
				</v-col>
				
			</v-row>
		</v-card-text>
	</v-card>
</template>
<script type="text/javascript">
	import GridTypeSearch from "@/components/face/GridTypeSearchByVideo.vue"
	import TableTypeSearch from "@/components/face/TableTypeSearchByVideo.vue"
	import FilterSearch  from "@/components/face/FilterSearchByVideoResults.vue"	
	export default{
		name : "ResultsSearchByVideo",
		props : ["open","infoToFilter", "currentHeight"], // 
		components: { TableTypeSearch , GridTypeSearch, FilterSearch},
		data : ()=>({
			listTypeSelection:[
				{ key:"grid", component:"GridTypeSearch", name: "grid"},
				// { key:"table", component:"TableTypeSearch", name: "table"},
			],
			selectedType:{
				key: 'grid',
				component : "GridTypeSearch",
			},

		}),
		methods:{
			renderSelectionType(item){
				this.selectedType=item;
			}
		}, // methods
	}
</script>